// Approximate coordinates for Pune areas (for map plotting)
export const AREA_COORDS = {
  Kothrud: [18.5074, 73.8077],
  Hinjewadi: [18.5983, 73.7386],
  Wakad: [18.5985, 73.7625],
  Baner: [18.5590, 73.7868],
  Aundh: [18.5636, 73.8074],
  "Viman Nagar": [18.5679, 73.9143],
  Kharadi: [18.5515, 73.9430],
  Hadapsar: [18.5089, 73.9260],
  "Koregaon Park": [18.5362, 73.8939],
  Camp: [18.5138, 73.8797],
  "Shivaji Nagar": [18.5308, 73.8475],
  Magarpatta: [18.5150, 73.9280],
  "Pimple Saudagar": [18.5980, 73.8020],
  Balewadi: [18.5750, 73.7690],
  Bavdhan: [18.5150, 73.7770],
  Kondhwa: [18.4670, 73.8990],
  Mundhwa: [18.5360, 73.9260],
  Keshavnagar: [18.5300, 73.9400],
  Wagholi: [18.5800, 73.9800],
  Pashan: [18.5380, 73.7900],
  Undri: [18.4560, 73.9200],
  Katraj: [18.4480, 73.8580],
  Warje: [18.4830, 73.8010],
  "NIBM Road": [18.4630, 73.9060],
};

export const PUNE_CENTER = [18.5204, 73.8567];

export function coordsFor(p, index = 0) {
  const base = AREA_COORDS[p.area] || PUNE_CENTER;
  // larger deterministic spiral jitter so multiple listings in one area don't overlap
  const angle = index * 2.399; // golden angle
  const radius = 0.006 + (index % 5) * 0.004;
  return [base[0] + radius * Math.cos(angle), base[1] + radius * Math.sin(angle)];
}
